import { render, staticRenderFns } from "./RPUserInfo.vue?vue&type=template&id=b2ca858a"
import script from "./RPUserInfo.vue?vue&type=script&lang=js"
export * from "./RPUserInfo.vue?vue&type=script&lang=js"
import style0 from "./RPUserInfo.vue?vue&type=style&index=0&id=b2ca858a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports